import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import { handleActions, createAction } from 'redux-actions';
import { LARGE, MEDIUM, SMALL, XLARGE } from '../../utils/withWidth';
import { updateStateReducer } from '../../utils/redux';

const changeSizeAction = createAction('LAYOUT_CHANGE_SIZE');

const xlargeWidth = 1220;
const largeWidth = 960;
const mediumWidth = 768;

export const reducer = handleActions({
  [changeSizeAction]: updateStateReducer,
}, { size: SMALL });


class ResizeHandler extends Component {
  constructor(props) {
    super(props);

    this.handler = debounce(() => this.handleResize(), 150);
    this.currentSize = SMALL;
  }

  componentDidMount() {
    document.addEventListener('resize', this.handler);
    this.handler();
  }

  componentWillUnmount() {
    document.removeEventListener('resize', this.handler);
  }

  handleResize() {
    const innerWidth = window.innerWidth;
    let size;

    if (innerWidth >= xlargeWidth) {
      size = XLARGE;
    } else if (innerWidth >= largeWidth) {
      size = LARGE;
    } else if (innerWidth >= mediumWidth) {
      size = MEDIUM;
    } else { // innerWidth < 768
      size = SMALL;
    }

    if (this.currentSize !== size) {
      this.currentSize = size;
      this.props.dispatch(changeSizeAction({ size }));
    }
  }

  render() {
    return null;
  }
}

ResizeHandler.propTypes = {
  dispatch: PropTypes.func,
};

export default connect()(ResizeHandler);



// WEBPACK FOOTER //
// ./src/app/components/ResizeHandler.js